import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

import AssetSegmentAdmin from '../Asset/AssetSegmentAdmin';

import DetailView from '../Common/DetailView';
import Dialog from 'material-ui/Dialog';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import FlatButton from 'material-ui/FlatButton';
import InfoIcon from 'material-ui/svg-icons/action/info';
import NotificationIcon from 'material-ui/svg-icons/social/notifications';


import PersonIcon from 'material-ui/svg-icons/social/person';
import EventStore from '../../stores/EventStore';
import EventAssetStore from '../../stores/EventAssetStore';
import EventReminderStore from '../../stores/EventReminderStore';
import EventActions from '../../actions/EventActionCreator';
import AssetActions from '../../actions/AssetActionCreator';

import ReminderSegmentAdmin from '../Reminder/ReminderSegmentAdmin';

import buildContextMenu from '../Common/BuildContextMenu';
import ROLES from '../../constants/Roles';
import { withId } from '../Common/Decorators';
import SelectAsset from '../Asset/SelectAsset';
import ErrorSnackbar from '../Common/ErrorSnackbar';

let timeout;

const EventSettings = React.createClass({

    getInitialState: function(){

        return {
            dialogOpen: false,
            dialogValue: null,
            name: '',
            location: {
                name: '',
                venue: {
                    name: ''
                }
            },
            status: {
                name: ''
            },
            description: '',
            timeStart: '',
            timeEnd: '',
            dateStart: '',
            dateEnd: '',
            displayGuests: 0,
            reminders: [],
            assets: [],
            assetList: [],
            actions: buildContextMenu([
                {
                    label: "Preview",
                    link: `/dashboard/event/${this.props.id}`,
                    icon: <InfoIcon/>
                },
                {
                    label: "Attendance",
                    link: `/dashboard/event/${this.props.id}/attendees`,
                    icon: <PersonIcon/>
                },
                {
                    type: 'divider'
                },
                {
                    label: "Add reminder",
                    link: `/dashboard/event/${this.props.id}/reminder/new`,
                    icon: <NotificationIcon/>
                },
                {
                    type: 'divider'
                },
                {
                    label: "Edit",
                    link: `/dashboard/event/${this.props.id}/edit`,
                    icon: <EditIcon/>
                },
                {
                    type: 'deleteDialog',
                    dialogType: 'menu',
                    value: this.props.id,
                    title: 'Delete event',
                    deleteAction: (id) => { EventActions.delete(id); browserHistory.push('/dashboard/events'); },
                    message: (<span>Are you sure you wish to delete this event?</span>),
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                }
            ], this.context.auth),
            links: {
                back: `/dashboard/event/${this.props.id}`,
                edit: '',
            }
        }
    },

    componentWillMount: function(){
        EventStore.addChangeListener(this.onChange);
        EventActions.getById(this.props.id);
        this.listeners = [
            EventAssetStore.addListener(this.onEventAssetChange),
            EventReminderStore.addListener(this.onRemindersChange),
        ];
        EventActions.getReminders(this.props.id);
        EventActions.listAssets(this.props.id);
        AssetActions.getAll();

        this.onRemindersChange();
    },

    componentWillUnmount: function() {
        EventStore.removeChangeListener(this.onChange);
        this.listeners.forEach(listener => listener.remove());
    },

    render: function(){

        return (
            <DetailView
                title={this.state.name}
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <ReminderSegmentAdmin
                        resourceId={this.props.id}
                        resourceName="event"
                        reminders={this.state.reminders}
                    />
                    <AssetSegmentAdmin
                        assets={this.state.assets}
                        addAction={this.openDialog}
                        deleteAction={(assetId) => EventActions.removeAsset(this.props.id, assetId)}
                    />
                </div>
                <Dialog
                    title="Add attachment"
                    open={this.state.dialogOpen}
                    modal={false}
                    onRequestClose={this.closeDialog}
                    actions={[
                        <FlatButton key="cancel" label="Cancel" onTouchTap={this.closeDialog} />,
                        <FlatButton key="add" label="Add" onTouchTap={this.addAsset} disabled={!this.state.dialogValue} />
                    ]}
                >
                    <SelectAsset
                        label="Attachment"
                        maxSearchResult={5}
                        clearOnSelect={false}
                        onSelect={this.selectAsset}
                        onUpdate={() => this.selectAsset()}
                    />
                </Dialog>
                <ErrorSnackbar/>
            </DetailView>

        );
    },

    onChange: function(){
        const event = EventStore.getById(this.props.id);
        this.setState(event);
    },
    onEventAssetChange: function() {
        const assets = EventAssetStore.getByEvent(this.props.id);
        if (assets !== undefined) {
            this.setState({assets});
        }
    },
    selectAsset(name, id) {
        this.setState({dialogValue: id});
    },
    addAsset: function() {
        EventActions.addAsset(this.props.id, this.state.dialogValue);
        this.closeDialog();
    },
    onRemindersChange: function() {
        const reminders = EventReminderStore.getByEvent(this.props.id);
        if (reminders !== undefined) {
            this.setState({reminders: reminders});
        }
    },
    openDialog() {
        this.setState({dialogOpen: true, dialogValue: null});
    },
    closeDialog: function() {
        this.setState({dialogOpen: false, dialogValue: null});
    },
});

EventSettings.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(EventSettings);
